<template>
  <div class="gap-general">
    <SmallBanner
      :icon="'cached'"
      :title="$t('forex-rollover-rates.title')"
      :description="$t('forex-rollover-rates.description')"
    />
    <div v-if="rates && rates.length" class="margin-general margin-less">
      <div class="forex-rollover-rates-table">
        <div class="search-container">
          <input
            class="search-input"
            v-model="searchText"
            type="text"
            placeholder="Search symbol"
          />
          <div class="icon-container">
            <span class="material-symbols-outlined" translate="no" @click="closeModal"
              >search</span
            >
          </div>
        </div>
        <table>
          <tbody>
            <tr>
              <th>Symbol</th>
              <th>Long</th>
              <th>Short</th>
            </tr>
            <tr v-for="(item, index) in filteredRates" :key="index">
              <td class="whit-flag">
                <img
                  class="flag-image"
                  :src="`/images/currency-flags/${item.symbol.toUpperCase()}.png`"
                />
                {{ item.symbol }}
              </td>
              <td>{{ item.long }}</td>
              <td>{{ item.short }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="disclaimer-content">
        <p>{{ $t("forex-rollover-rates.disclaimer") }}</p>
        <ul>
          <li>{{ $t("forex-rollover-rates.disclaimer1") }}</li>
          <li>{{ $t("forex-rollover-rates.disclaimer2") }}</li>
        </ul>
      </div>
    </div>

    <client-only>
      <LazyInvestment
        class="investment var-invest-two"
        :label="'forex-contract-specs.ready'"
        :buttonConfigs="[
          {
            type: 'external',
            href: getExternalUrl('/register/1/live-account'),
            class: 'primary-button-medium',
            textKey: 'forex-contract-specs.btn'
          }
        ]"
      />
    </client-only>
  </div>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import SmallBanner from "~/components/SmallBanner.vue";

import { useI18n } from "vue-i18n";
const { getExternalUrl } = useExternalUrl();
const { t } = useI18n();
const title = t("seo.trading-conditions.forex.rollover-rates.title");
const description = t(
  "seo.trading-conditions.forex.rollover-rates.description"
);

useSeoMeta({
  title: title,
  ogTitle: title,
  twitterTitle: title,
  description: description,
  ogDescription: description,
  twitterDescription: description,
});

const rates = ref([]);
const searchText = ref("");

const filteredRates = computed(() => {
  if (!searchText.value) {
    return rates.value;
  }
  return rates.value.filter((rate) =>
    rate.symbol.toLowerCase().includes(searchText.value.toLowerCase())
  );
});

const fetchData = async () => {
  try {
    const response = await fetch(
      "https://3akic58pxh.execute-api.us-west-2.amazonaws.com/prod/list"
    );

    if (response.ok) {
      const data = await response.json();
      if (data.data) {
        data.data.forEach((item) => {
          rates.value.push({
            symbol: item.symbol,
            long: item.long_value,
            short: item.short_value,
          });
        });
      }
    } else {
      console.error("Error al obtener los datos");
    }
  } catch (error) {
    console.error("Error al realizar la solicitud:", error);
  }
};

onMounted(() => {
  fetchData();
});
</script>
